import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EntityUnavailableService } from 'src/app/services/entities/entity-unavailable.service';
import { PlanningService, TrucksForDate } from 'src/app/services/planning/planning.service';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-trucks',
    templateUrl: './trucks.component.html',
    styleUrls: ['./trucks.component.scss'],
    standalone: false,
})
export class TrucksComponent implements OnInit, OnDestroy {
    @Input() print: boolean;
    @Input() private date: Date;
    @Input() private fromDate: Date;
    @Input() private toDate: Date;

    private subscriptions = new Subscription();

    public trucks: TrucksForDate;
    public todaysTruckCount = 0;

    constructor(
        private planningService: PlanningService,
        private entityUnavailableService: EntityUnavailableService
    ) {}

    ngOnInit() {
        this.subscriptions.add(
            this.planningService.getCountOfUsedTrucks(this.fromDate, this.toDate, this.date).subscribe({
                next: trucks => {
                    this.trucks = trucks;
                },
            })
        );

        const endOfDay = Utils.setTime(new Date(this.date), 23, 59);
        this.subscriptions.add(
            this.entityUnavailableService.getTrucksAvailableForRange(this.date, endOfDay).subscribe({
                next: availableTrucks => {
                    this.todaysTruckCount = availableTrucks;
                },
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
